import { render, staticRenderFns } from "./bookList2.vue?vue&type=template&id=65d52ec6&scoped=true&"
import script from "./bookList2.vue?vue&type=script&lang=js&"
export * from "./bookList2.vue?vue&type=script&lang=js&"
import style0 from "./bookList2.vue?vue&type=style&index=0&id=65d52ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d52ec6",
  null
  
)

export default component.exports